import { fromJS } from 'immutable';

import {
  SET_IS_PA_ABOVE_ATC_RENDERED,
  SET_IS_VD_ABOVE_ATC_RENDERED,
} from './constants';

// The initial state of the App
export const initialState = fromJS({
  loading: false,
  error: false,
  currentUser: false,
  userData: {
    repositories: false,
  },
  isVDAboveATCRendered: false,
  isProductAddonsAboveATCRendered: false,
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_IS_VD_ABOVE_ATC_RENDERED:
      return state.set('isVDAboveATCRendered', action.isVDAboveATCRendered);
    case SET_IS_PA_ABOVE_ATC_RENDERED:
      return state.set(
        'isProductAddonsAboveATCRendered',
        action.isProductAddonsAboveATCRendered,
      );
    default:
      return state;
  }
}

export default appReducer;
